import { useMemo } from 'react';
import { InfiniteSearchSelect, SelectProps } from '../common/components';
import { useInfiniteSearchAccessGroupIdsQuery } from './query/useAccessGroupsQuery';

export interface AccessGroupAutoCompleteProps
  extends Omit<SelectProps<number | number[]>, 'pages'> {}

export function AccessGroupAutoComplete(props: AccessGroupAutoCompleteProps) {
  const { value } = props;
  const selectedIds = useMemo(
    () =>
      (Array.isArray(value) ? value : [value]).filter(
        (item): item is number => typeof item === 'number',
      ),
    [value],
  );

  return (
    <InfiniteSearchSelect
      {...props}
      searchOptions={{ selectedIds }}
      useSearchHook={useInfiniteSearchAccessGroupIdsQuery}
    />
  );
}
